import React from 'react';
import { useSelector } from 'react-redux';

import {
  Container, Photo, Description,
} from './styled';

import { selectWebsiteTheme } from '../../../store/slices/website';

const ItemPlaceholder = () => {
  const { colors } = useSelector(selectWebsiteTheme);

  return (
    <Container>
      <Photo
        bgColor={colors[2].color}
      />
      <Description />
    </Container>
  );
};

export default ItemPlaceholder;
